export default[
  {
    "name": "金融",
    "code": "01",
    "imgUrl": require('@/common/images/report/mobile/sortIcon/sortIcon1.png')
  },
  {
    "name": "科技",
    "code": "02",
    "imgUrl": require('@/common/images/report/mobile/sortIcon/sortIcon2.png')
  },
  {
    "name": "创业",
    "code": "03",
    "imgUrl": require('@/common/images/report/mobile/sortIcon/sortIcon3.png')
  },
  {
    "name": "资本",
    "code": "04",
    "imgUrl": require('@/common/images/report/mobile/sortIcon/sortIcon4.png')
  },
  {
    "name": "互联网",
    "code": "05",
    "imgUrl": require('@/common/images/report/mobile/sortIcon/sortIcon5.png')
  },
  {
    "name": "游戏",
    "code": "06",
    "imgUrl": require('@/common/images/report/mobile/sortIcon/sortIcon6.png')
  },
  {
    "name": "消费",
    "code": "07",
    "imgUrl": require('@/common/images/report/mobile/sortIcon/sortIcon7.png')
  },
  {
    "name": "教育",
    "code": "08",
    "imgUrl": require('@/common/images/report/mobile/sortIcon/sortIcon8.png')
  },
  {
    "name": "地产",
    "code": "09",
    "imgUrl": require('@/common/images/report/mobile/sortIcon/sortIcon9.png')
  },
  {
    "name": "医疗",
    "code": "10",
    "imgUrl": require('@/common/images/report/mobile/sortIcon/sortIcon10.png')
  },
  {
    "name": "健康",
    "code": "11",
    "imgUrl": require('@/common/images/report/mobile/sortIcon/sortIcon11.png')
  },
  {
    "name": "文娱",
    "code": "12",
    "imgUrl": require('@/common/images/report/mobile/sortIcon/sortIcon12.png')
  },
  {
    "name": "环保",
    "code": "13",
    "imgUrl": require('@/common/images/report/mobile/sortIcon/sortIcon13.png')
  },
  {
    "name": "IT",
    "code": "14",
    "imgUrl": require('@/common/images/report/mobile/sortIcon/sortIcon14.png')
  },
  {
    "name": "智能制造",
    "code": "15",
    "imgUrl": require('@/common/images/report/mobile/sortIcon/sortIcon15.png')
  },
  {
    "name": "服务业",
    "code": "16",
    "imgUrl": require('@/common/images/report/mobile/sortIcon/sortIcon16.png')
  },
  {
    "name": "新零售",
    "code": "17",
    "imgUrl": require('@/common/images/report/mobile/sortIcon/sortIcon17.png')
  },
  {
    "name": "新媒体",
    "code": "18",
    "imgUrl": require('@/common/images/report/mobile/sortIcon/sortIcon18.png')
  },
  {
    "name": "新材料",
    "code": "19",
    "imgUrl": require('@/common/images/report/mobile/sortIcon/sortIcon19.png')
  },
  {
    "name": "连锁",
    "code": "20",
    "imgUrl": require('@/common/images/report/mobile/sortIcon/sortIcon20.png')
  },
  {
    "name": "SaaS",
    "code": "21",
    "imgUrl": require('@/common/images/report/mobile/sortIcon/sortIcon21.png')
  },
  {
    "name": "区块链",
    "code": "22",
    "imgUrl": require('@/common/images/report/mobile/sortIcon/sortIcon22.png')
  },
  {
    "name": "人工智能",
    "code": "23",
    "imgUrl": require('@/common/images/report/mobile/sortIcon/sortIcon23.png')
  },
  {
    "name": "营销",
    "code": "24",
    "imgUrl": require('@/common/images/report/mobile/sortIcon/sortIcon24.png')
  },
  {
    "name": "商业管理",
    "code": "25",
    "imgUrl": require('@/common/images/report/mobile/sortIcon/sortIcon25.png')
  },
  {
    "name": "制造业",
    "code": "26",
    "imgUrl": require('@/common/images/report/mobile/sortIcon/sortIcon26.png')
  },
  {
    "name": "其他",
    "code": "27",
    "imgUrl": require('@/common/images/report/mobile/sortIcon/sortIcon27.png')
  },
  {
    "name": "",
    "code": "",
    "imgUrl": ""
  }
]